import authorization from '@/functions/authorization.js'
import axios from 'axios'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import store from '../store'
Vue.use(VueCookies)
export default {
  CheckRoleAccess,
  CheckRoleActiveMenu
}

async function CheckRoleAccess (param) {
  store.dispatch('SET_MENU')
  if (store.getters.MenuToolbarDefault.length < 1) {
    try {
      var path = param.name
      var Menu = []
      // var menu =  store.getters.menu
      var payload = {
        AccessToken: Vue.$cookies.get('OneAccessToken')
      }
      var Headers = {
        AccountId: Vue.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      const result = await axios.post(
        process.env.VUE_APP_API_FACTORING_SERVICE +
          'config-notify/MenuUserDefault',
        { Data: dataEncode },
        { headers }
      )
      if (result.data.Status === 'OK') {
        Menu = result.data.Message.ForFront[0].menu
        if (Vue.$cookies.get('BusinessId') === '00000') {
          store.dispatch('GET_MENU_DEFAULT', [Menu[0]])
        } else {
          store.dispatch('GET_MENU_DEFAULT', Menu)
        }
        // store.dispatch('GET_ROLE_ACCESS', result.data.Message.RoleAccess)
      } else {
        Menu = store.state.MenuToolbarDefault
      }
      const resultData = setRoleAccess(Menu, path)
      return new Promise((resolve) => {
        resolve(resultData)
      })
    } catch (err) {
      const resultData = setRoleAccess(Menu, path)
      return new Promise((resolve) => {
        resolve(resultData)
      })
    }
  } else {
    var pathName = param.name
    const resultData = setRoleAccess(
      store.getters.MenuToolbarDefault,
      pathName
    )
    return new Promise((resolve) => {
      resolve(resultData)
    })
  }
}

function setRoleAccess (menu, path) {
  for (var i of menu) {
    if (i.description.includes(path)) {
      return i.RoleAccess
    }
    for (var j of i.children) {
      if (j.description.includes(path)) {
        return j.RoleAccess
      }
      for (var k of j.list) {
        if (k.description.includes(path)) {
          return k.RoleAccess
        }
      }
    }
  }
}

function CheckRoleActiveMenu (_roledata) {
  return _roledata
}
